module.exports = __webpack_public_path__ + "img/content1.f804f3cf.png";